import React, { useEffect, useState } from "react";
import { Providerlist } from "../../../api/helper";
import { useNavigate } from "react-router-dom";

const ProvidersDataPatient = () => {
  const [providerdata, setproviderdata] = useState(null);
  const navigate = useNavigate();

  const GetProvider = async () => {
    // ?page=${page}&limit=1000`
    try {
      const response = await Providerlist();
      setproviderdata(response?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetProvider();
  }, []);

  return (
    <div
      className="dashboard-cards"
      style={{ paddingLeft: 30, paddingRight: 30 }}
    >
      <div className="appointments-table-container12">
        <table className="appointments-table12">
          <thead>
            <tr>
              {/* <th>ID</th> */}
              <th>Image</th>
              <th>Full Name</th>
              <th>Specialization</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Address</th>
              <th>Years of Experience</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {(providerdata?.length ?? 0) > 0 ? (
              providerdata.map((appointment, idx) => {
                const key = appointment?._id ?? `prov-${idx}`;

                const imgSrc =
                  typeof appointment?.image === "string" && appointment.image.trim()
                    ? appointment.image
                    : "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";

                const fullName =
                  [appointment?.firstName, appointment?.lastName].filter(Boolean).join(" ") ||
                  "";

                const categoryName = appointment?.categoryId?.[0]?.name ?? "—";
                const phone = appointment?.phone ?? "—";
                const email = appointment?.email ?? "—";
                const practiceLocation = appointment?.practiceLocation ?? "—";
                const experience = appointment?.experience ?? "—";
                const canBook = Boolean(appointment?._id);

                return (
                  <tr key={key}>
                    <td>
                      <img src={imgSrc} className="client-image1" alt={fullName} />
                    </td>

                    <td>{fullName}</td>
                    <td>{categoryName}</td>
                    <td>{phone}</td>
                    <td>{email}</td>
                    <td>{practiceLocation}</td>
                    <td>{experience}</td>

                    <td>
                      <div
                        role="button"
                        aria-disabled={!canBook}
                        onClick={() =>
                          canBook &&
                          navigate("/BookAppointments", {
                            state: { providerId: appointment._id },
                          })
                        }
                        className="book_now_class"
                        style={{
                          cursor: canBook ? "pointer" : "not-allowed",
                          opacity: canBook ? 1 : 0.6,
                          pointerEvents: canBook ? "auto" : "none",
                        }}
                        title={canBook ? "Book Now" : "Missing provider id"}
                      >
                        Book Now
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", padding: 20 }}>
                  No Providers Found
                </td>
              </tr>
            )}

          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProvidersDataPatient;
